import axios from 'axios';
import { ICrudPutAction } from 'react-jhipster';

import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { IReportMenu } from 'app/shared/model/reportMenu.model';

export const ACTION_TYPES = {
  FETCH: 'reportSettings/FETCH',
  UPDATE: 'reportSettings/UPDATE',
  ADD: 'reportSettings/ADD',
  UPDATE_ROLE: 'reportSettings/UPDATE_ROLE',
  RESET: 'reportSettings/RESET',
  DELETE_REPORT: 'DELETE_REPORT',
  UPDATE_DELETE_FLAG: 'UPDATE_DELETE_FLAG',
};

const initialState = {
  loading: false,
  errorMessage: null,
  deleteReport: false,
  deleteFailure: false,
  settings: [],
  reportSettings: {
    name: '',
    slug: '',
    reportUrl: '',
  },
  settingsDetail: {
    paymentEditThreshold: 0,
    costKm: 0,
    flatDriverFee: 0,
    countryId: '0',
    countryName: '',
    paymentMethod: '',
    currencyConverter: 0,
    babyAgeLimit: 0,
    motherDeliveryDateLimit: 0,
    currencySymbol: '',
  },
  updating: false,
  updateSuccess: false,
};

export type ReportSettingsState = Readonly<typeof initialState>;

// Reducer
export default (state: ReportSettingsState = initialState, action): ReportSettingsState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.ADD):
    case REQUEST(ACTION_TYPES.UPDATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };

    case REQUEST(ACTION_TYPES.DELETE_REPORT):
      return {
        ...state,
        deleteReport: false,
        deleteFailure: false,
      };

    case FAILURE(ACTION_TYPES.FETCH):
    case FAILURE(ACTION_TYPES.ADD):
    case FAILURE(ACTION_TYPES.UPDATE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case FAILURE(ACTION_TYPES.DELETE_REPORT):
      return {
        ...state,
        deleteReport: false,
        deleteFailure: true,
      };

    case SUCCESS(ACTION_TYPES.UPDATE_DELETE_FLAG):
      return {
        ...state,
        deleteReport: action.payload,
      };

    case SUCCESS(ACTION_TYPES.DELETE_REPORT):
      return {
        ...state,
        deleteReport: true,
        deleteFailure: false,
      };
    case SUCCESS(ACTION_TYPES.ADD):
    case SUCCESS(ACTION_TYPES.UPDATE_ROLE):
      // not adding update action type to prevent double execution
      return {
        ...state,
        updating: false,
        updateSuccess: true,
      };

    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const deleteReportDashboard = reportId => {
  const requestUrl = `api/delete-report-menu/${reportId}`;
  return {
    type: ACTION_TYPES.DELETE_REPORT,
    payload: axios.delete(requestUrl),
  };
};

export const updateReportSettings: ICrudPutAction<IReportMenu> = reportSettings => async dispatch => {
  const id = reportSettings.id;
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE,
    payload: axios.put('/api/edit-report-menu', reportSettings),
  });

  await dispatch({
    type: ACTION_TYPES.UPDATE_ROLE,
    payload: axios.put('/api/edit-report-menu-role', {
      reportMenuId: id,
      roles: reportSettings.roles,
    }),
  });

  return result;
};

export const updateReportDeleteFlag = () => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_DELETE_FLAG,
    payload: false,
  });
};

export const addReportSettings: ICrudPutAction<IReportMenu> = reportSettings => async dispatch => {
  const id = reportSettings.id;
  const result = await dispatch({
    type: ACTION_TYPES.ADD,
    payload: axios.post('/api/add-report-menu', reportSettings),
  });
  return result;
};

export const reset = () => dispatch => {
  return dispatch({
    type: ACTION_TYPES.RESET,
  });
};
